import React, { useCallback, useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useDispatch } from 'react-redux'
import { markOrderReadyThunk } from '../../../../../../redux/thunk/wolt/orders'
import MarkReadyButton from '../index'

export const useMarkReadyButton = (selectedOrder, isOpen) => {
	const { t } = useTranslation()
	const dispatch = useDispatch()
	const [markReadyState, setMarkReadyState] = useState(null)
	const markedReady = selectedOrder?.platformMetaData?.markedReady === true
	const isWoltOrder = selectedOrder?.platformMetaData?.platformType === 'WOLT_PLUGIN'
	const isPlatformDriverOrder = selectedOrder?.orderType === 'DELIVERY_BY_PLATFORM' ||
		(selectedOrder?.orderType === 'DELIVERY' && !!selectedOrder?.deliveryMetaData?.partner?.type)
	const markReadyVisible = isWoltOrder && isPlatformDriverOrder &&
		['BEING_PREPARED', 'READY'].includes(selectedOrder?.status?.status)
	const status = markReadyState && markReadyState.orderId === selectedOrder?.orderId ? markReadyState.status : null
	const isMarkReadyActionable = markReadyVisible && !markedReady && status !== 'pending' && status !== 'succeeded'

	useEffect(() => {
		setMarkReadyState(null)
	}, [isOpen])

	const handleMarkReady = useCallback(async () => {
		const orderId = selectedOrder?.orderId
		setMarkReadyState({ orderId, status: 'pending' })
		const isMarkedReady = await dispatch(markOrderReadyThunk(orderId))
		setMarkReadyState({ orderId, status: isMarkedReady ? 'succeeded' : 'error' })
	}, [dispatch, selectedOrder?.orderId])

	return {
		text: t('order.modal.mark_ready'),
		show: markReadyVisible,
		disabled: !isMarkReadyActionable,
		onClick: handleMarkReady,
		customButton: ({ key, ...props }) => <MarkReadyButton key={key} {...props} order={selectedOrder} status={status} />,
	}
}
